module.exports = __webpack_public_path__ + "static/media/Lib4.95464746.jpg";